import React, { useRef } from 'react'
import { Button, Input, TextArea } from 'antd-mobile'
import { FaTelegramPlane } from 'react-icons/fa'
import { FaCheck, FaTimes } from 'react-icons/fa'
import { FaImage } from 'react-icons/fa'

const ChatInput = ({
  value,
  onChange,
  onSend,
  disabled,
  placeholder = 'Leave a message',
  isEditing = false,
  onCancelEdit,
  onImageUpload
}) => {
  const fileInputRef = useRef(null)

  const handleIconClick = () => {
    fileInputRef.current.click()
  }

  const handleFileChange = (e) => {
    const file = e.target.files[0]
    if (file && onImageUpload) {
      onImageUpload(file)
      e.target.value = ''
    }
  }

  return (
    <div className="chat-input-wrapper">
      <FaImage
        size={28} 
        className="chat-input-image-icon"
        style={{ cursor: 'pointer', marginRight: 10, marginLeft: 6, color: '#2b4b8f' }}
        onClick={handleIconClick}
        title="Attach image"
      />
      <input
        type="file"
        accept="image/*"
        ref={fileInputRef}
        style={{ display: 'none' }}
        onChange={handleFileChange}
      />
      <TextArea
        className="chat-input-field"
        value={value}
        onChange={onChange}
        placeholder={isEditing ? 'Edit message' : placeholder}
        autoSize={{ minRows: 1, maxRows: 5 }}
      />

      {isEditing ? (
        <>
          <Button
            className="edit-cancel-button"
            onClick={onCancelEdit}
          >
            <FaTimes size={16} color="white" style={{ fontWeight: 400 }} />
          </Button>
          <Button
            className="edit-confirm-button"
            onClick={onSend}
            disabled={disabled}
          >
            <FaCheck size={16} color="white" style={{ fontWeight: 400 }} />
          </Button>
        </>
      ) : (
        <Button className="send-button" onClick={onSend} disabled={disabled}>
          <FaTelegramPlane size={26} color="#2b4b8f" />
        </Button>
      )}
    </div>
  )
}

export default ChatInput
